// extracted by mini-css-extract-plugin
module.exports = {"request-detail":"+lQ-d"};